import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import AutoPlaySettings from "Base/settings/AutoPlaySettings";
import SoundManager from "Engine/soundManager/SoundManager";
import EntryPoint from "Engine/EntryPoint";

export default class ShowWinningsState extends BaseState {
    constructor(stateData) {
        super(stateData);
    }

    start() {
        super.start();
        SoundManager.play('sounds/mainGame/SmallWin', 1, false);
        SoundManager.play('sounds/mainGame/WinPresentation1', 1, false);
        if (!AutoPlaySettings.active && !EntryPoint.GameModel.freeSpins && !EntryPoint.GameModel.freeBetsStarted) {
            this.complete();
        }
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('winningsController:allWinningsComplete', this.onAllWinningsComplete, this);
    }

    onAllWinningsComplete() {
        if(this.active) {
            this.complete();
        }
    }

    /*onEnd() {
        super.onEnd();
        SoundManager.stop('sounds/mainGame/SmallWin');
    }*/
}